var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('PlateTitle',{attrs:{"title":"投保历史记录"}}),_c('List',{staticClass:"list"}),_c('a-pagination',{staticClass:"pagination",attrs:{"default-current":6,"total":500}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }